import React from "react";
import { BsFileEarmarkWordFill } from "react-icons/bs";
import { FaFilePdf } from "react-icons/fa";
import { RiFileExcel2Fill } from "react-icons/ri";

import * as Styles from "./styles";

interface DataProps {
  nome: string;
  tipoArquivo: string;
  tamanhoArquivo: string;
  base64: string;
}

interface Props {
  data: DataProps;
}

const ToolTipContainer: React.FC<Props> = ({ data }) => {
  const generatePreview = () => {
    switch (data?.tipoArquivo) {
      case "image/jpeg":
        return <Styles.Preview src={data?.base64} />;
      case "image/png":
        return <Styles.Preview src={data?.base64} />;
      case "application/pdf":
        return (
          <FaFilePdf color="#333333" size={30} style={{ marginBottom: 4 }} />
        );
      case "application/msword":
        return (
          <BsFileEarmarkWordFill
            color="#333333"
            size={30}
            style={{ marginBottom: 4 }}
          />
        );
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return (
          <BsFileEarmarkWordFill
            color="#333333"
            size={30}
            style={{ marginBottom: 4 }}
          />
        );
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return (
          <RiFileExcel2Fill
            color="#333333"
            size={30}
            style={{ marginBottom: 4 }}
          />
        );
      default:
        return null;
    }
  };

  const generateTipo = () => {
    switch (data?.tipoArquivo) {
      case "image/jpeg":
        return "JPG";
      case "image/png":
        return "PNG";
      case "application/pdf":
        return "PDF";
      case "application/msword":
        return "DOC";
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return "DOCX";
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return "DOCX";
      default:
        return null;
    }
  };

  return (
    <Styles.Container>
      {generatePreview()}
      <Styles.RowSpace>
        <Styles.Text>Nome: </Styles.Text>
        <Styles.Text>{data?.nome}</Styles.Text>
      </Styles.RowSpace>
      <Styles.RowSpace>
        <Styles.Text>Tipo: </Styles.Text>
        <Styles.Text>{generateTipo()}</Styles.Text>
      </Styles.RowSpace>
      <Styles.RowSpace>
        <Styles.Text>Tamanho: </Styles.Text>
        <Styles.Text>{data?.tamanhoArquivo}</Styles.Text>
      </Styles.RowSpace>
    </Styles.Container>
  );
};

export default ToolTipContainer;
